type PushToSftpMode =
  | "push"
  | "track"
  | "textNote"
  | "download"
  | "pushedDownload";

export const getModalTitle = (mode: PushToSftpMode): string => {
  switch (mode) {
    case "track":
      return "Select Batch - Run Status";
    case "textNote":
      return "Text Note and Status Letter";
    case "download":
    case "pushedDownload":
      return "Select Batch - Download File";
    default:
      return "Select Batch - Push to SFTP";
  }
};
